
import React, {Component} from 'react';
import {connect} from 'react-redux'
import { Label, Pagination, Button, Modal, Tabs, Tab, Row, Col } from 'react-bootstrap';
import { Box } from 'reactjs-admin-lte';
// import { Box } from 'reactjs-admin-lte';
import FontAwesome from 'react-fontawesome';
// import Select from 'react-select';
import StockEditTyreModal from './StockEditTyreModal'
import './Stock.css';
import StockStore from 'stores/StockStore';
import IframeModal from 'component/element/IframeModal'

class StockTyreProductTransactionModal extends Component {

  constructor(props) {
    super(props)

    this.state = this.initState()
  }

  initState(){
    return {
      itemPerPage: 5,
      totalPage: 0,
      activePage: 1,
      pageStatus: false,
      data: [],
      transaction_record:[],
      tabSelect:0,
      dataSet:{}
    }
  }

  componentDidMount() {
    console.log('xx')
  }

  componentWillReceiveProps(newProps){
    if(newProps.show && newProps.show!==this.props.show){
      this.loadStockTransactionRecord(newProps.stockType,newProps.itemData)
      this.setState({dataSet:newProps.itemData})
    }
  }

  loadStockTransactionRecord(stockType,item) {
    this.setState(this.initState())

    StockStore.loadStockTransactionRecord(stockType, item.itemnum,  (result)=> {
      let data = result.data
      data.push({ added_date: item.added_date, record_type: 'init', request_by: item.added_by, quantity: 'ไม่มีข้อมูล' })
      
      this.setState({ transaction_record: data })
    })
  }

  onStockProductTransactionCloseClick() {
    this.props.onHide()
  }

  onWorkClick(workNo){
    this.props.onHide()
    if(window.show_work_doc!==undefined)
      window.show_work_doc(workNo);
    else
      alert("open "+workNo)
  }

  onPrintClick(item){
    let url = ''
    if (process.env.NODE_ENV === "development") {
      url  = 'https://demo-fast.bigfix.co/sriracha/pdf/?sr='+item.recordid+'&file=stockrecord_doc'
    } else{
      url = './pdf/?sr='+item.recordid+'&file=stockrecord_doc'
    }
    this.refs.iframe.getWrappedInstance().loadUrl(url)    
  }

  onTabsSelect(key) {
    this.setState({tabSelect:key})
  }

  onEditTyreSaveClick() {
    if (this.props.onEditTyreSaveClick!==undefined)
      this.props.onEditTyreSaveClick()  
  }

  renderWorkViewHead(){
      let {messages} = this.props
      return (
        <th className='text-center'>{messages['Document']}</th>
      )
  }

  renderTable() {
    let {messages} = this.props
    return(
      <div className='display-overflow'>
        <table className="table table-responsive table-hover table-bordered-solid">
          <thead>
            <tr>
              <th>{messages['Record Date']}</th>
              <th>{messages['Type']}</th>
              <th>{messages['Note']}</th>
              <th>{messages['Requester']}</th>
              <th className='text-center'>{messages['Quantity']}</th>
              {this.renderWorkViewHead()}              
            </tr>
          </thead>
          <tfoot>
            <tr>
              <th>{messages['Record Date']}</th>
              <th>{messages['Type']}</th>
              <th>{messages['Note']}</th>
              <th>{messages['Requester']}</th>
              <th className='text-center'>{messages['Quantity']}</th>
              {this.renderWorkViewHead()}              
            </tr>
          </tfoot>
          <tbody>
            {this.renderRowData()}
          </tbody>
        </table>
      </div>
    )
  }

  handleSelect(e) {
    let {itemPerPage} = this.state
    let {transaction_record} = this.state
    let data = []
    let start = (e * 5) - 5
    if (e === 1) {
      start = 0
    }

    transaction_record.forEach(function(item,index) {
      if (index>=start&&index<itemPerPage*e) {
        data.push(item)
      }
    })
    this.setState({activePage:e,data:data,pageStatus:true})
  }

  renderPagination() {
    let {messages} = this.props
    let {activePage,totalPage,itemPerPage} = this.state
    let allPage = this.state.transaction_record.length / itemPerPage
    totalPage = Math.ceil(allPage)
    return(
              <div className="text-right" style={{display:totalPage>1?'':'none'}}>
                <Pagination
                  prev={messages['Previous']}
                  next={messages['Next']}
                  first={false}
                  last={false}
                  ellipsis
                  boundaryLinks
                  items={totalPage}
                  maxButtons={5}
                  activePage={activePage}
                  onSelect={this.handleSelect.bind(this)}
                  style={{marginBottom:'0'}}
                />
              </div>
    )
  }

  renderWorkView(item){
  
      let desc = item.description!==undefined?item.description:''
      let arr = desc.split(" ");
      if(arr.length===2){
        let wo = arr[1]
        let woarr = wo.split("/")
        if(woarr.length===2){
          return (
            <Button onClick={this.onWorkClick.bind(this,wo)}><FontAwesome name='files-o'/>ใบงาน</Button>
          )    
        }
      }
      return ('')   
  }

  renderTransactionView(item){
    let {messages} = this.props
    return (
      <Button onClick={this.onPrintClick.bind(this,item)}><FontAwesome name='print'/>&nbsp;{messages['Item']}</Button>
    )
  }

  getPaginationData(transaction_record) {
    let {itemPerPage,pageStatus} = this.state
    let data = []

    if (!pageStatus) {
      transaction_record.forEach(function(item,index) {
        if (index<itemPerPage)
          data.push(item)
      })
      return data
    } else {
      return this.state.data
    }  
  }

  renderSummay(){
    let {unit,quantity} = this.props
    let importQ =0,exportQ = 0,balaneceQ =0
    this.state.transaction_record.map((item, index) => {
      
      if (item.record_type === "import") {
        importQ += item.quantity*1
      } else if (item.record_type === "export") {
        exportQ += item.quantity*1
      } else if (item.record_type === "init") {
        
      }
      return item
    })
    balaneceQ = importQ - exportQ 
    return (
      <div>
        จากข้อมูล <Label bsStyle={'success'}>นำเข้า {importQ} {unit}</Label> 
        <Label bsStyle={'primary'}>นำออก/เบิก {exportQ} {unit}</Label> 
        <Label bsStyle={'warning'}>คงเหลือเข้าออก {balaneceQ} {unit}</Label> 
        <Label bsStyle={'default'}>คงเหลือหน้าตาราง {quantity} {unit}</Label>
      </div>
    )
  }

  renderRowData() {
    let {data} = this.state
    let {messages} = this.props
    if (undefined !== this.state.transaction_record && this.state.transaction_record.length) {
      data = this.getPaginationData(this.state.transaction_record)
      return(
        data.map((item, index) => {
          let record_type = ''
          if (item.record_type === "import") {
            record_type = messages['Import']
          } else if (item.record_type === "export") {
            record_type = messages['Export']
          } else if (item.record_type === "lock_export") {
            record_type = 'ล็อกสินค้าไว้' 
          } else if (item.record_type === "release_export") {
            record_type = 'ตัดสต็อกสินค้า' 
          } else if (item.record_type === "return_export") {
            record_type = 'คืนสินค้าไว้'      
          } else if (item.record_type === "init") {
            record_type = messages['Get Started']
          }
          return (
            <tr key={index} className={this.getRowStyle(item, index)} >
              <td>{ item.added_date }</td>
              <td>{ record_type }</td>
              <td>{ item.description }</td>
              <td>{ item.request_by }</td>
              <td className='text-center'>{ item.quantity }</td>
              <td className='text-center'>{this.renderTransactionView(item)} {this.renderWorkView(item)}</td>
            </tr>
          )  
        })
      )     
    } else { 
      return(<tr><td colSpan={4}>ไม่พบข้อมูล</td></tr>)
    }  
  }

  getRowStyle(item, index) {
    if (item.record_type === "import") {
      return 'green-row'
    } else if (item.record_type === "export") {
      return 'blue-row'
    } else if (item.record_type === "lock_export") {
      return 'blue-row'
    }
  }

  renderInfoTable() {
    let {itemData} = this.props
    return(
      <div>
        <StockEditTyreModal
          // show={this.props.show}
          dataSet={itemData}
          tool={this.props.tool}
          stockType={this.props.tool}
          // onHide={()=>{this.setState({showEditTyreModal:false})}}
          onSave={this.onEditTyreSaveClick.bind(this)}
        />  
      </div>
    )
  }

  renderTabs() {
    let rTitle = 'ข้อมูลทั่วไป'
    let rTitle1 = 'ประวัติยาง'
    let rTitle2 = 'ประวัติในสต็อก'
    return(
      <Row>        
          <Col md={12}>
            <Tabs 
              activeKey={this.state.tabSelect} 
              animation={false} 
              id="transaction-tabs"
              onSelect={this.onTabsSelect.bind(this)}
            >
              <Tab 
                eventKey={0}
                title={rTitle}
              >
                {this.renderInfoTable()}  
              </Tab>
              <Tab 
                eventKey={1}
                title={rTitle1}
              >
                <Box>
                  <Box.Body>
                    <br />
                  </Box.Body>
                </Box>  
              </Tab>
              <Tab 
                eventKey={2}
                title={rTitle2}
              >
                <Box>
                  <Box.Body>
                    {this.renderTable()}
                    {this.renderSummay()}
                    {this.renderPagination()}
                  </Box.Body>
                </Box>  
              </Tab>
          </Tabs>
        </Col>
      </Row>      
    )
  }

  render(){
    let {messages} = this.props
    return (
      <Modal bsSize="large" show={this.props.show} onHide={this.onStockProductTransactionCloseClick.bind(this)}>
        <Modal.Header closeButton>
          <Modal.Title>
            ข้อมูลยาง {this.props.itemData.serial_no}/{this.props.itemData.tyre_brand}/{this.props.itemData.tyre_model}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {this.renderTabs()}
          <IframeModal ref='iframe' title={messages['Print Document']}/>
        </Modal.Body>
        <Modal.Footer>
          <Button className="btn-default" onClick={ this.onStockProductTransactionCloseClick.bind(this) }>
            <FontAwesome name='remove' /> {messages['Cancel']}
          </Button>            
        </Modal.Footer>  
      </Modal>  
    )
  }
}

StockTyreProductTransactionModal.defaultProps = {
  show : false
}

export default StockTyreProductTransactionModal = connect(
  (state) => ({messages: state.message.view.tyre.stock.StockTyreProductTransactionModal}),null,null,{withRef:true}
)(StockTyreProductTransactionModal);





// WEBPACK FOOTER //
// ./src/view/tyre/stock/StockTyreProductTransactionModal.js